import { render, staticRenderFns } from "./task-file.vue?vue&type=template&id=2359a57a&"
import script from "./task-file.vue?vue&type=script&lang=js&"
export * from "./task-file.vue?vue&type=script&lang=js&"
import style0 from "./task-file.vue?vue&type=style&index=0&lang=less&scroped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports